import { createAction } from 'redux-actions'
import { createRequestActions as request } from 'store/actionCreators'
import { GET_STORIES } from 'app/constants/api/feed'

export const setUsersList = request('USERS/SET_USERS', () => ({
  request: {
    url: `${GET_STORIES}/users`,
  },
}))

export const setMentionUser = createAction('USERS/SET_MENTION_USER', user => ({
  user,
}))
